var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"keydown":_vm.onKeyDown}},[_c('validated-input',{ref:"input",attrs:{"label":_vm.label,"validate":_vm.validate,"disabled":_vm.disabled},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }